// extracted by mini-css-extract-plugin
module.exports = {"main":"BOD_main__33ffI"};